var React = require('react');

function Oab12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"12/Listing"},React.createElement("path",{"id":"Icon","fillRule":"evenodd","clipRule":"evenodd","d":"M6 4V0H2V4H0V8H2V24H6V8H24V4H6ZM22 20V10H8V20H22Z","fill":"currentColor"})));
}

Oab12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 24 24","fill":"none"};

module.exports = Oab12;

Oab12.default = Oab12;
